/* eslint-disable react/no-unused-state */
import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import EditTable from '../../EditableTable';
import Pagination from '../../Pagination';

const DateFormatter = ({ value }) => (
  <div>
      {new Date(parseInt(value, 10)).toDateString()}
  </div>);

DateFormatter.propTypes = {
  value: PropTypes.string.isRequired,
};

const MoneyFormatter = ({ value }) => (
  <div>
      ${parseFloat(value/100).toFixed(2)}
  </div>);

MoneyFormatter.propTypes = {
  value: PropTypes.string.isRequired,
};

const ViewFormatter = ({ value }) => (
  <Link className="badge badge-success" to={`/pages/receipt?t=${value}`}>Approve</Link>);

ViewFormatter.propTypes = {
  value: PropTypes.string.isRequired,
};

const ViewReceiptFormatter = ({ value }) => (
  <a href={value} target="_blank" className="badge badge-warning" >View Receipt</a>);

ViewReceiptFormatter.propTypes = {
  value: PropTypes.string.isRequired,
};

export default class ReceiptsListTable extends PureComponent {
  static propTypes = {
    data: PropTypes.array
  };

  constructor() {
    super();
    this.heads = [
      {
        key: 'receipt_date',
        name: 'Receipt Date',
        sortable: true,
        formatter: DateFormatter,
      },
      {
        key: 'element_name',
        name: 'Staff Name',
        sortable: true,
      },
      {
        key: 'amount',
        name: 'Amount',
        sortable: true,
        formatter: MoneyFormatter,
      },
      {
        key: 'reason',
        name: 'Reason',
      },
      {
        key: 'timestamp',
        name: ' ',
        sortable: false,
        formatter: ViewFormatter
      },
      {
        key: 'image_url',
        name: ' ',
        sortable: false,
        formatter: ViewReceiptFormatter
      },
    ];

    this.state = {
      pageOfItems: [],
    };
  }

  onChangePage = (pageOfItems) => {
    // update state with new page of items
    this.setState({ pageOfItems });
  };

  onSelectSize = (e) => {
    this.setState({
      pageSize: parseInt(e.target.value, 10)
    });
  }
  
  render() {
    return (
      <Col md={12} lg={12}>
        {this.props.data.length > 0
          && <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">Pending Approval</h5>
              </div>
              <EditTable heads={this.heads} rows={this.props.data} />
            </CardBody>
          </Card>
        }
      </Col>
    );
  }
}
